import PropertyService from './PropertyService';
import PropertySearchService from './PropertySearchService';
import CorelogicApiHandler from './CorelogicApiHandler';

const services = {
  property: new PropertyService(CorelogicApiHandler),
  propertySearch: new PropertySearchService(CorelogicApiHandler),
};

export default services;
